import { AdditionalParams, Data, createRequest, platform } from "@shared/platform-api/requests"
import { kmToMileConverterWithDecimals } from "@shared/utils/formatters/kmToMiles"
import { createRequestHook } from "../../createRequestHook"
import { FleetEntriesMileageSortKeys, FleetEntryWithMileage, makeFleetEntriesWithMileage } from "./types"
import { isNewPipelinePolicy } from "../../../utils"

export type FleetEntriesWithMileageSearchParams = {
  tag?: string
  after?: string
  term?: string
  sortKey?: FleetEntriesMileageSortKeys
  sortOrder?: "ASC" | "DESC"
  limit?: number
  minimumDistanceDriven?: string | number
}
export type UseGetFleetEntriesWithMileageInput = Readonly<{
  connectedVrns: ReadonlyArray<string>
  id: string
}>

export type SearchVehiclesInput = UseGetFleetEntriesWithMileageInput & AdditionalParams<FleetEntriesMileageSortKeys>

const searchVehicles = createRequest<SearchVehiclesInput, Data<FleetEntryWithMileage>>(async (input, getToken) => {
  const { connectedVrns, ...searchObject } = input
  const useNewPipeline = isNewPipelinePolicy(input.id)
  const fleetEntries = await platform(getToken).trips.searchVehicles({
    ...searchObject,
    policyId: searchObject.id,
    sortKey: `vrn`,
    ...(useNewPipeline ? { dbName: `athena` } : {}),
  })

  const items = makeFleetEntriesWithMileage(
    fleetEntries.items.map((entry) => ({
      isConnected: connectedVrns.includes(entry.vrn),
      name: entry.name!,
      mileage: kmToMileConverterWithDecimals(entry.total.distanceKm!),
      vrn: entry.vrn!,
    }))
  )
  return {
    ...fleetEntries,
    items,
  }
})
const getFleetEntriesWithMileage = createRequest<
  UseGetFleetEntriesWithMileageInput,
  ReadonlyArray<FleetEntryWithMileage>
>(async (input, getToken) => {
  const useNewPipeline = isNewPipelinePolicy(input.id)
  const { connectedVrns, ...searchObject } = input
  const fleetEntries = await platform(getToken).trips.searchVehicles({
    ...searchObject,
    policyId: searchObject.id,
    sortKey: `vrn`,
    ...(useNewPipeline ? { dbName: `athena` } : {}),
  })

  return makeFleetEntriesWithMileage(
    fleetEntries.items.map((entry) => ({
      isConnected: connectedVrns.includes(entry.vrn),
      name: entry.name!,
      mileage: kmToMileConverterWithDecimals(entry.total.distanceKm!),
      vrn: entry.vrn!,
    }))
  )
})

export const useGetFleetEntriesWithMileage = createRequestHook(getFleetEntriesWithMileage)

export const useSearchVehicles = createRequestHook<
  UseGetFleetEntriesWithMileageInput,
  Data<FleetEntryWithMileage>,
  FleetEntriesMileageSortKeys
>(searchVehicles)
